import { Box, Button, Paper, TextField } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import type { Filters } from "../types";
import { defaultFilters, isDefaultFilters } from "../types";
import { AssignedStateToggle } from "../../../../components/AssignedStateToggle";
import { FormatToggles } from "./FormatToggles";
import { DatePicker } from "../../../../components/DatePicker";

export type AttachmentFiltersProps = {
  value: Filters;
  onChange: (next: Filters) => void;
};

export const AttachmentFilters = ({
  value,
  onChange,
}: AttachmentFiltersProps) => {
  const update = <K extends keyof Filters>(key: K, next: Filters[K]) =>
    onChange({ ...value, [key]: next });

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <AssignedStateToggle
            label="Invoice"
            icon={<RequestQuoteIcon />}
            value={value.invoice}
            onChange={(v) => update("invoice", v)}
          />
          <AssignedStateToggle
            label="Transaction"
            icon={<ReceiptLongIcon />}
            value={value.transaction}
            onChange={(v) => update("transaction", v)}
          />
          <FormatToggles
            value={value.formats}
            onChange={(next) => update("formats", next)}
          />
        </Box>
        <TextField
          size="small"
          label="Filename contains"
          value={value.namePattern}
          onChange={(e) => update("namePattern", e.target.value)}
          sx={{ minWidth: 200 }}
        />
        <DatePicker
          mode="range"
          label="Date"
          value={{ from: value.from, to: value.to }}
          onChange={(next) =>
            onChange({ ...value, from: next.from, to: next.to })
          }
        />
        {!isDefaultFilters(value) && (
          <Button
            size="small"
            startIcon={<ClearIcon />}
            onClick={() => onChange(defaultFilters)}
          >
            Clear
          </Button>
        )}
      </Box>
    </Paper>
  );
};
